import { ProductState } from "@/cms/sanity.types";

export type PriceList = Omit<
  NonNullable<ProductState["priceLists"]>[number],
  "_key" | "_type"
>;

export type Price = { current: number | null; previous: number | null };

export function getPriceOffer({
  originalItemPrice,
  priceLists,
  total,
  quantity = 1,
}: {
  originalItemPrice?: number | null;
  quantity?: number;
  total?: number | null;
  priceLists?: PriceList[] | null;
}): Price {
  if (!originalItemPrice) return { current: null, previous: null };
  const originalItemTotal = originalItemPrice * quantity;

  if (total || total === 0)
    return {
      current: total,
      previous: total < originalItemTotal ? originalItemTotal : null,
    };

  const offerItemPrice = priceLists
    ? Math.min(...priceLists.map<number>(({ price }) => price ?? Infinity))
    : null;
  const offerTotal = offerItemPrice ? offerItemPrice * quantity : null;

  if (offerTotal && offerTotal < originalItemTotal)
    return {
      current: offerTotal,
      previous: originalItemTotal,
    };

  return { current: originalItemTotal, previous: null };
}
